const headerMobile = document.getElementById('headerMobile');
const btnScrollMobileHeaderRight = document.getElementById('btnScrollMobileHeaderRight');
const btnScrollMobileHeaderLeft = document.getElementById('btnScrollMobileHeaderLeft');
const menuMobileHeaderText = document.getElementById('menuMobileHeaderText');
const pageHeaderMobile = document.getElementById('page-header--mobile');

if (headerMobile && pageHeaderMobile && btnScrollMobileHeaderLeft && btnScrollMobileHeaderRight) {
  const headerHoverBg = pageHeaderMobile.querySelector('.header-hover-bg');

  btnScrollMobileHeaderRight.onclick = () => {
    if (headerHoverBg) {
      headerHoverBg.style.right = '0';
      headerHoverBg.style.left = '12.45%';
    }
    menuMobileHeaderText.scrollLeft = 1000;
    headerMobile.style.margin = '0 0 0 -75%';
  };

  btnScrollMobileHeaderLeft.onclick = () => {
    if (headerHoverBg) {
      headerHoverBg.style.right = '12.45%';
      headerHoverBg.style.left = '0';
    }
    menuMobileHeaderText.scrollLeft = -1000;
    headerMobile.style.margin = '0 0 0 0';
  };
}

/**
 * Desktop Header
 * Set left side initially to "active"
 */

const pageHeader = document.getElementById('page-header');
const leftSide = document.querySelector('#page-header .header-text-left');
const rightSide = document.querySelector('#page-header .header-text-right');
const leftHoverBg = document.querySelector('#page-header .header-text-left .header-hover-bg');
const leftSideTitle = leftSide && leftSide.querySelector('h2');
const rightSideTitle = rightSide && rightSide.querySelector('h2');

if (pageHeader && leftSide && rightSide && rightSideTitle && leftSideTitle) {
  leftHoverBg.style.opacity = 1;
  leftSideTitle.style.color = 'var(--text-gray)';

  leftSide.addEventListener('mouseleave', () => {
    leftHoverBg.style.opacity = '';
    leftSideTitle.style.color = '';
  });

  rightSide.addEventListener('mouseenter', () => {
    leftHoverBg.style.opacity = '';
    leftSideTitle.style.color = '';
  });
}
